<template>
  <div class="serviceway">
    <uni-popup ref="dicPopup" type="bottom" @change="changePop">
      <picker-view
        v-if="visible"
        :value="map[field]"
        class="picker-view"
        :indicator-style="indicatorStyle"
        :immediate-change="true"
        @change="change"
      >
        <picker-view-column>
          <div
            v-for="(item, index) in arr"
            :key="index"
            :class="[{ mdrug: code === 'drug_usage_meng_his' || 'drug_use_time' }, 'item']"
            style="font-size: 0.64rem; font-weight: 400"
          >
            {{ item.value }}
          </div>
        </picker-view-column>
      </picker-view>
    </uni-popup>
  </div>
</template>

<script>
import { getKeyValue } from '@/views/funcPuzzle/utils/util.js'

export default {
  props: {
    options: {
      type: Array,
      default: () => {
        return []
      }
    },
    value: {
      type: [String, Array, Object],
      default: ''
    },
    code: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    },
    field: {
      type: String,
      default: ''
    },
    isHave: {
      type: Boolean,
      default: false
    }
  },
  computed: {},
  watch: {
    visible: {
      handler(val) {
        if (
          val &&
          ['drug_use_time', 'drug_usage_meng_his', 'drug_usage_his'].includes(this.code) &&
          !this.isHave
        ) {
          this.start()
        }
        if (this.value) {
          const index = this.arr.findIndex(val => val.code === this.value)
          this.$set(this.map, this.field, [index])
        }
      }
    },
    code: {
      handler(val) {
        if (val) {
          if (this.options.length > 0) {
            this.arr = this.options
          } else {
            this.arr = this.getKeyValue(val)
          }
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      arr: [],
      indicatorStyle: 'height: 1.066667rem;',
      map: {}
    }
  },

  methods: {
    changePop(e) {
      this.$emit('update:visible', e.show)
      if (this.options.length > 0) {
        this.arr = this.options
      }
      if (e.show && this.arr[0]) {
        // 需要动态响应 $set
        this.$set(this.map, this.field, [
          this.arr.findIndex(item => {
            return item.code === this.value
          })
        ])
      }
    },
    getKeyValue,
    start(item) {
      const val = this.value || this.arr[0].code
      this.$emit('start', val, this.field)

      this.$set(this.map, this.field, val)
      this.$emit('change', val, this.field)
    },
    open() {
      this.$refs.dicPopup.open()
    },
    close() {
      this.$refs.dicPopup.close()
    },
    change(item) {
      this.$set(this.map, this.field, item.detail.value)
      const val = this.arr[item.detail.value[0]].code
      this.$emit('change', val, this.field)
    }
  }
}
</script>
<style lang="scss" scoped>
.btn_row {
  display: flex;
  width: 100%;
  background-color: #fff;
  justify-content: space-between;
  .delete_btn,
  .confirm_btn {
    height: 1.706667rem;
    background-color: #fff;
    padding: 0 0.853333rem;
    line-height: 2.56rem;
    color: #2772ff;
    font-size: 0.64rem;
  }
}

::v-deep.picker-view {
  height: 8.533333rem;
  background: #fff;
  .item {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    height: 1.066667rem;
  }
}
</style>
